import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { REQUEST, C300 } = GW_SERVICES_PREFIXES;

// Получение tenant по параметрам
export const GetTenantsCardsByPhone = (params: IParams) => {
  return API.get(`/${C300}/models/tenants/`, undefined, params);
};

// Получение other_tenant (иные лица) по параметрам
export const GetOtherTenantsCardsByPhone = (params: IParams) => {
  return API.get(`/${C300}/models/other_tenants/`, undefined, params);
};

/* Получение статистики жителя */
export const GetTenantStats = (id: string) =>
  API.get(`/${C300}/forms/requests/tenant_stats/`, id);

/*Получение тикетов жителя*/
export const GetTenantTicketsStats = (id: string) =>
  API.get(`/${C300}/forms/tickets/tenant_stats/`, id);

/*Получение кол-во звонков жителя*/
export const GetTenantCallsStats = (id: string) =>
  API.get(`/${C300}/forms/calls/tenant_stats/`, id);

/* Получение оплат жителя по секторам */
export const GetTenantSectors = (id: string) =>
  API.get(`/${C300}/tenants/sectors/${id}/`);

// Создание иного лица
export const CreateOtherTenant = (data: any) => {
  return API.gatewayPost(`/${C300}/models/other_tenants/`, data);
};

// Новое API добавления контактных данных в карточку жильца
export const SetTenantContacts = (id: string, data: any) => {
  return API.gatewayPatch(`/${C300}/forms/requests/tenant_contacts/`, id, data);
};

// Новое API добавления контактных данных в карточку жильца
export const SetEmployeeContacts = (id: string, data: any) => {
  return API.gatewayPatch(
    `/${C300}/forms/requests/employee_contacts/`,
    id,
    data
  );
};

// Обновление данных стороннего частного лица
export const SetOtherPersonContacts = (id: string, data: any) => {
  return API.gatewayPatch(`/${REQUEST}/others/person/`, id, data);
};

// Обновление данных представителя сторонней организации
export const SetOtherEmployeeContacts = (id: string, data: any) => {
  return API.gatewayPatch(`/${REQUEST}/others/employee/`, id, data);
};

// Получение оценок по жителю
export const GetTenantRating = (tenantId: string) =>
  API.get(`/${REQUEST}/request/rate/tenant/`, tenantId);

/** Оценить жителя */
export const RateTenantNEW = (tenantId: string, params: IParams) =>
  API.gatewayPatch(`/${REQUEST}/request/rate/tenant/`, tenantId, params);

// Получить соцсети по номеру телефона, params: {phone_number: code+number}
export const GetNumberSocialNetworks = (params: IParams) =>
  API.get(`/${C300}/tenants/change_number_social_networks/`, undefined, params);

// Изменить соцсети по номеру телефона, data: {phone_number: code+number, telegram: boolean, whatsapp: boolean, viber: boolean}
export const PostNumberSocialNetworks = (data: IParams) =>
  API.gatewayPost(`/${C300}/tenants/change_number_social_networks/`, data);

// Отправка ссылки на оплату по задолженностям жителя
export const PostNotificationSend = (data: IParams) =>
  API.gatewayPost(`/${C300}/notifications/debt/send/`, data);
